<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		class="guiare-glyph"
		:aria-label="ariaLabel"
		role="img"
	>
		<defs>
			<linearGradient :id="gradientId" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
				<stop offset="0%" :stop-color="primary" stop-opacity="1" />
				<stop offset="100%" :stop-color="primary" stop-opacity="0.55" />
			</linearGradient>
			<linearGradient :id="gradientHighlightId" x1="0" y1="0" x2="40" y2="40">
				<stop offset="0%" stop-color="#ffffff" stop-opacity="0.75" />
				<stop offset="100%" stop-color="#ffffff" stop-opacity="0.15" />
			</linearGradient>
		</defs>

		<!-- Hexágono arredondado -->
		<path
			d="M20 2.5 L34.1 10.6 V29.4 L20 37.5 L5.9 29.4 V10.6 Z"
			:fill="`url(#${gradientId})`"
			stroke="rgba(255,255,255,0.35)"
			stroke-width="0.6"
			stroke-linejoin="round"
		/>

		<!-- Spark central (estilo 4 pontas) -->
		<path
			d="M20 12 L21.4 18.6 L28 20 L21.4 21.4 L20 28 L18.6 21.4 L12 20 L18.6 18.6 Z"
			:fill="`url(#${gradientHighlightId})`"
		/>

		<!-- Pontinho menor pra dar profundidade -->
		<circle cx="29" cy="11" r="1.4" fill="#ffffff" fill-opacity="0.85" />
	</svg>
</template>

<script>
let uid = 0;

export default {
	name: 'GuIAreGlyph',

	props: {
		size: {
			type: [Number, String],
			default: 28,
		},
		ariaLabel: {
			type: String,
			default: 'guIAre',
		},
	},

	data() {
		const id = ++uid;
		return {
			gradientId: `guiareGlyphGrad-${id}`,
			gradientHighlightId: `guiareGlyphGradHl-${id}`,
		};
	},

	computed: {
		primary() {
			return this.$vuetify?.theme?.themes?.light?.primary || '#FBDC04';
		},
	},
};
</script>

<style scoped>
.guiare-glyph {
	display: inline-block;
	filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.12));
}
</style>
